import React from 'react';
import classNames from 'classnames';
import styles from './DataGrid.module.scss';

interface RowProps {
  label: string;
  value?: React.ReactNode | null;
  labelClassName?: string;
  valueClassName?: string;
  showEmpty?: boolean;
}

export interface DataGridProps {
  className?: string;
  labelClassName?: RowProps['labelClassName'];
  valueClassName?: RowProps['valueClassName'];
  data: Pick<RowProps, 'label' | 'value'>[];
  showEmpty?: RowProps['showEmpty'];
}

const Row: React.FC<RowProps> = ({ labelClassName, valueClassName, label, value, showEmpty }) => {
  if (!value && !showEmpty) {
    return null;
  }

  return (
    <>
      <div className={labelClassName}>{label}</div>
      <div className={valueClassName}>{value}</div>
    </>
  );
};

export const DataGrid: React.FC<DataGridProps> = ({ className, labelClassName, valueClassName, data, showEmpty }) => {
  return (
    <div className={classNames(styles.container, className)}>
      {data.map((item) => (
        <Row
          key={item.label}
          label={item.label}
          value={item.value}
          labelClassName={labelClassName}
          valueClassName={valueClassName}
          showEmpty={showEmpty}
        />
      ))}
    </div>
  );
};
